import GreetingCardGiftCard from '@/src/common/components/elements/Layout/GreetingCardGiftCard'
import Card from '@/src/common/components/marketing/cards/Card'

interface ICard {
    isPlastic: boolean
    image: string
    name?: string
    message?: string
    greetingCardPreviewUrl?: string
}

const GiftPreview = ({
    isPlastic,
    image,
    name,
    message,
    greetingCardPreviewUrl,
}: ICard) => {
    if (isPlastic) {
        if (greetingCardPreviewUrl) {
            return (
                <GreetingCardGiftCard
                    greetingCardImage={greetingCardPreviewUrl}
                    cardImage={image}
                />
            )
        }

        return (
            <Card
                size={'lg'}
                image={image}
                isExtended={false}
                overlayType={'partial'}
                showCustomFields={true}
                name={name}
                message={message}
                data-testid={'card-image'}
                showLoader={!image}
            />
        )
    }

    return (
        <Card
            size={'lg'}
            image={image}
            isExtended={false}
            overlayType={'none'}
            data-testid={'card-image'}
            showLoader={!image}
        />
    )
}
export default GiftPreview
